import React from 'react';
import { Icon } from 'tea-component';
import { useIntl } from 'umi';
import './index.less';

const Loading = (props: any) => {
  const { className, style } = props;
  const {formatMessage} = useIntl()
  const { text = formatMessage({id:'common_loading'})  } = props;
  return (
    <div className={`dtb-loading ${className || ''}`} style={style}>
      <Icon size="l" type="loading" className="loading-icon" />
      {text}
    </div>
  );
};

export default Loading;
